/* tslint:disable */
/* eslint-disable */
/**
 * ROC API
 * Referral Outbound Center (ROC) API for managing outbound referrals between post-acute care facilities.  All endpoints require a valid JWT. Organization and user identity are derived from the token — callers never pass these in query params or request bodies. 
 *
 * The version of the OpenAPI document: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Recipient } from './Recipient';
import {
    RecipientFromJSON,
    RecipientFromJSONTyped,
    RecipientToJSON,
    RecipientToJSONTyped,
} from './Recipient';

/**
 * 
 * @export
 * @interface ReferralDetail
 */
export interface ReferralDetail {
    /**
     * 
     * @type {string}
     * @memberof ReferralDetail
     */
    referral_id: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralDetail
     */
    lead_id: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralDetail
     */
    sender_facility_id: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralDetail
     */
    sender_organization_id: string;
    /**
     * 
     * @type {Date}
     * @memberof ReferralDetail
     */
    target_discharge_date: Date;
    /**
     * 
     * @type {string}
     * @memberof ReferralDetail
     */
    referral_type: ReferralDetailReferralTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ReferralDetail
     */
    status: ReferralDetailStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ReferralDetail
     */
    close_reason: ReferralDetailCloseReasonEnum | null;
    /**
     * 
     * @type {Date}
     * @memberof ReferralDetail
     */
    sent_at: Date;
    /**
     * 
     * @type {Date}
     * @memberof ReferralDetail
     */
    confirmed_at: Date;
    /**
     * 
     * @type {Date}
     * @memberof ReferralDetail
     */
    closed_at: Date;
    /**
     * 
     * @type {Date}
     * @memberof ReferralDetail
     */
    created_at: Date;
    /**
     * 
     * @type {string}
     * @memberof ReferralDetail
     */
    created_by_user_id: string;
    /**
     * 
     * @type {Date}
     * @memberof ReferralDetail
     */
    updated_at: Date;
    /**
     * 
     * @type {string}
     * @memberof ReferralDetail
     */
    updated_by_user_id: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralDetail
     */
    first_name: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralDetail
     */
    last_name: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralDetail
     */
    ssn: string;
    /**
     * 
     * @type {Date}
     * @memberof ReferralDetail
     */
    dob: Date;
    /**
     * 
     * @type {Date}
     * @memberof ReferralDetail
     */
    latest_activity_at?: Date;
    /**
     * 
     * @type {Array<Recipient>}
     * @memberof ReferralDetail
     */
    recipients: Array<Recipient>;
}


/**
 * @export
 */
export const ReferralDetailReferralTypeEnum = {
    HomeHealth: 'home_health',
    Snf: 'snf',
    Ltac: 'ltac',
    Dme: 'dme',
    Dialysis: 'dialysis'
} as const;
export type ReferralDetailReferralTypeEnum = typeof ReferralDetailReferralTypeEnum[keyof typeof ReferralDetailReferralTypeEnum];

/**
 * @export
 */
export const ReferralDetailStatusEnum = {
    Draft: 'draft',
    Sent: 'sent',
    Confirmed: 'confirmed',
    Closed: 'closed'
} as const;
export type ReferralDetailStatusEnum = typeof ReferralDetailStatusEnum[keyof typeof ReferralDetailStatusEnum];

/**
 * @export
 */
export const ReferralDetailCloseReasonEnum = {
    ConfirmedElsewhere: 'confirmed_elsewhere',
    Declined: 'declined',
    Lost: 'lost',
    Withdrawn: 'withdrawn'
} as const;
export type ReferralDetailCloseReasonEnum = typeof ReferralDetailCloseReasonEnum[keyof typeof ReferralDetailCloseReasonEnum];


/**
 * Check if a given object implements the ReferralDetail interface.
 */
export function instanceOfReferralDetail(value: object): value is ReferralDetail {
    if (!('referral_id' in value) || value['referral_id'] === undefined) return false;
    if (!('lead_id' in value) || value['lead_id'] === undefined) return false;
    if (!('sender_facility_id' in value) || value['sender_facility_id'] === undefined) return false;
    if (!('sender_organization_id' in value) || value['sender_organization_id'] === undefined) return false;
    if (!('target_discharge_date' in value) || value['target_discharge_date'] === undefined) return false;
    if (!('referral_type' in value) || value['referral_type'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('close_reason' in value) || value['close_reason'] === undefined) return false;
    if (!('sent_at' in value) || value['sent_at'] === undefined) return false;
    if (!('confirmed_at' in value) || value['confirmed_at'] === undefined) return false;
    if (!('closed_at' in value) || value['closed_at'] === undefined) return false;
    if (!('created_at' in value) || value['created_at'] === undefined) return false;
    if (!('created_by_user_id' in value) || value['created_by_user_id'] === undefined) return false;
    if (!('updated_at' in value) || value['updated_at'] === undefined) return false;
    if (!('updated_by_user_id' in value) || value['updated_by_user_id'] === undefined) return false;
    if (!('first_name' in value) || value['first_name'] === undefined) return false;
    if (!('last_name' in value) || value['last_name'] === undefined) return false;
    if (!('ssn' in value) || value['ssn'] === undefined) return false;
    if (!('dob' in value) || value['dob'] === undefined) return false;
    if (!('recipients' in value) || value['recipients'] === undefined) return false;
    return true;
}

export function ReferralDetailFromJSON(json: any): ReferralDetail {
    return ReferralDetailFromJSONTyped(json, false);
}

export function ReferralDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferralDetail {
    if (json == null) {
        return json;
    }
    return {
        
        'referral_id': json['referral_id'],
        'lead_id': json['lead_id'],
        'sender_facility_id': json['sender_facility_id'],
        'sender_organization_id': json['sender_organization_id'],
        'target_discharge_date': (new Date(json['target_discharge_date'])),
        'referral_type': json['referral_type'],
        'status': json['status'],
        'close_reason': json['close_reason'],
        'sent_at': (new Date(json['sent_at'])),
        'confirmed_at': (new Date(json['confirmed_at'])),
        'closed_at': (new Date(json['closed_at'])),
        'created_at': (new Date(json['created_at'])),
        'created_by_user_id': json['created_by_user_id'],
        'updated_at': (new Date(json['updated_at'])),
        'updated_by_user_id': json['updated_by_user_id'],
        'first_name': json['first_name'],
        'last_name': json['last_name'],
        'ssn': json['ssn'],
        'dob': (new Date(json['dob'])),
        'latest_activity_at': json['latest_activity_at'] == null ? undefined : (new Date(json['latest_activity_at'])),
        'recipients': ((json['recipients'] as Array<any>).map(RecipientFromJSON)),
    };
}

export function ReferralDetailToJSON(json: any): ReferralDetail {
    return ReferralDetailToJSONTyped(json, false);
}

export function ReferralDetailToJSONTyped(value?: ReferralDetail | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'referral_id': value['referral_id'],
        'lead_id': value['lead_id'],
        'sender_facility_id': value['sender_facility_id'],
        'sender_organization_id': value['sender_organization_id'],
        'target_discharge_date': ((value['target_discharge_date']).toISOString().substring(0,10)),
        'referral_type': value['referral_type'],
        'status': value['status'],
        'close_reason': value['close_reason'],
        'sent_at': ((value['sent_at']).toISOString()),
        'confirmed_at': ((value['confirmed_at']).toISOString()),
        'closed_at': ((value['closed_at']).toISOString()),
        'created_at': ((value['created_at']).toISOString()),
        'created_by_user_id': value['created_by_user_id'],
        'updated_at': ((value['updated_at']).toISOString()),
        'updated_by_user_id': value['updated_by_user_id'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'ssn': value['ssn'],
        'dob': ((value['dob']).toISOString().substring(0,10)),
        'latest_activity_at': value['latest_activity_at'] == null ? undefined : ((value['latest_activity_at']).toISOString()),
        'recipients': ((value['recipients'] as Array<any>).map(RecipientToJSON)),
    };
}

